
import uniqueid from 'lodash.uniqueid';
import Icon from '../../../../icon';
import Gutter from '../../../../gutter';
import StyleClassNamesBuilder from '../../../../../styles/helpers/StyleClassNamesBuilder';
import {
  StyleColorSchemeType,
  StyleSizeType,
  StylePositionType,
} from '../../../../../styles/enums';
import { IconType } from '../../../../icon/enums';
import { CheckboxProperty } from './enums';
import CheckboxProps from './mixins/CheckboxProps';
import { ControlEventType } from '../../enums';

export default {
  name: 'Checkbox',
  components: {
    Gutter,
    Icon,
  },
  mixins: [CheckboxProps],
  data() {
    return {
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
      IconType,
      CheckboxProperty,
    };
  },
  computed: {
    inputId() {
      return this[CheckboxProperty.Id] || uniqueid(this.$options.name);
    },
    checkboxClassnames() {
      return new StyleClassNamesBuilder('checkbox')
        .addClassName(this[CheckboxProperty.ClassName])
        .build();
    },
    checkboxWrapperClassNames() {
      return new StyleClassNamesBuilder('checkbox__wrapper')
        .addConditionClassName('checked', this[CheckboxProperty.Value])
        .addConditionClassName('disabled', this[CheckboxProperty.Disabled])
        .addConditionClassNames(Object.values(StyleSizeType), this[CheckboxProperty.Size])
        .build();
    },
  },
  methods: {
    handleClick(event) {
      event.preventDefault();
      this.$emit(ControlEventType.Change, !this[CheckboxProperty.Value]);
    },
  },
};
